import React, { useState, useEffect } from 'react';

// MUI
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { parseCalculatedVal, generateTableKeys } from '../Util/HandleCalc';

const StyledTextField = styled(TextField)(({ disabled }) => ({
  fontSize: '1em',
  '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
    top: '-8px !important',
  },
  ...(disabled && {
    '& .MuiOutlinedInput-multiline': {
      background: 'rgba(248, 248, 248, 1) !important',
      color: 'black !important',
    },
  }),
}));

function LongTextInput({ data }) {
  const {
    answers,
    column,
    rowIndex,
    columnIndex,
    updateValue,
    isReadOnly,
    tableCells,
    size,
    isRS,
  } = data;
  const [text, setText] = useState(null);

  // Check if this cell has a calculation
  useEffect(() => {
    if (text == null) setText(answers[rowIndex][columnIndex].calculatedValue);
    // For deleting a row in repeatable sections
    else if (isRS && text != answers[rowIndex][columnIndex].calculatedValue)
      setText(answers[rowIndex][columnIndex].calculatedValue);
    // Else if table cells exist and the default value includes a ={}
    else if (
      tableCells != null &&
      tableCells[column.id] &&
      tableCells[column.id][rowIndex] &&
      tableCells[column.id][rowIndex].defaultValue &&
      tableCells[column.id][rowIndex].defaultValue.match(
        /(\={(?:\[??[^\[]*?\}))|"([0-9+ ]+)"/g
      ) != null &&
      text != null
    ) {
      // Get the table keys
      const getKeys = generateTableKeys(answers);

      // Get the updating value
      const updatingVal = {
        defaultValue: answers[rowIndex][columnIndex].defaultValue,
        calculatedValue: text,
      };

      // Perform the calculation on the value
      const calcVal = parseCalculatedVal(updatingVal, getKeys[0], getKeys[1]);

      // If the calculated value is different from the curr text val
      // And the answers calc value is also different
      // Update the value
      if (
        calcVal.calculatedValue != text &&
        answers[rowIndex][columnIndex].calculatedValue !=
          calcVal.calculatedValue
      ) {
        setText(calcVal.calculatedValue);
        updateValue(rowIndex, columnIndex, calcVal.calculatedValue, true);
      }
    }
  }, [answers]);

  const handleOnBlur = () => {
    if (text === answers[rowIndex][columnIndex].calculatedValue) return;
    updateValue(rowIndex, columnIndex, text, false);
  };

  return (
    text != null && (
      <StyledTextField
        fullWidth
        variant="outlined"
        multiline
        minRows={3}
        maxRows={8}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onBlur={handleOnBlur}
        disabled={isReadOnly}
        id={`table-row-${data.rowIndex}-col-${data.columnIndex}`}
        size={size}
      />
    )
  );
}

export default LongTextInput;
